/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type appQuickbooks_viewer$ref = any;
export type appQuickbooks_QueryVariables = {||};
export type appQuickbooks_QueryResponse = {|
  +viewer: ?{|
    +actualPersonId: ?string,
    +component: ?string,
    +$fragmentRefs: appQuickbooks_viewer$ref,
  |}
|};
export type appQuickbooks_Query = {|
  variables: appQuickbooks_QueryVariables,
  response: appQuickbooks_QueryResponse,
|};
*/


/*
query appQuickbooks_Query {
  viewer {
    actualPersonId
    component(name: "app_quickbooks")
    ...appQuickbooks_viewer
    id
  }
}

fragment appQuickbooks_viewer on Viewer {
  id
  company {
    id
    quickbooksEnabled
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "app_quickbooks"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"app_quickbooks\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "appQuickbooks_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "appQuickbooks_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "appQuickbooks_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "quickbooksEnabled",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "appQuickbooks_Query",
    "operationKind": "query",
    "text": "query appQuickbooks_Query {\n  viewer {\n    actualPersonId\n    component(name: \"app_quickbooks\")\n    ...appQuickbooks_viewer\n    id\n  }\n}\n\nfragment appQuickbooks_viewer on Viewer {\n  id\n  company {\n    id\n    quickbooksEnabled\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '182092b6bff2de7e73e1d95fbdf126bc';

module.exports = node;
